<template>
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-adclickreport__adclickreport">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.id" placeholder="请输入ID" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button icon="el-icon-search" @click="getDataList()">{{ $t('query') }}</el-button>
          <el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="info" icon="el-icon-download" @click="exportHandle()">{{ $t('export') }}</el-button>
        </el-form-item>
<!--        <el-form-item>-->
<!--          <el-button v-if="$hasPermission('adclickreport:adclickreport:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>-->
<!--        </el-form-item>-->
<!--        <el-form-item>-->
<!--          <el-button v-if="$hasPermission('adclickreport:adclickreport:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>-->
<!--        </el-form-item>-->
        <el-form-item>
          <el-select  v-if="$hasPermission('adclickreport:adclickreport:export')" v-model="dataForm.exportScaleOptionsValue"  clearable placeholder="导出比例（默认 100%）" @change="handleOperChange">
            <el-option
                v-for="item in exportScaleOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="广告分类">
          <el-select v-model="dataForm.adType" placeholder="请选择分类" clearable filterable @change="getpSonDict($event)">
            <el-option
                v-for="item in pDict"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="汇总时间">
          <el-date-picker
            v-model="dateRange"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00', '23:59:59']"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-popover placement="bottom" width="300" trigger="click" v-model="columnFilterVisible">
            <div class="column-filter-panel">
              <div class="filter-header">
                <span>列显示设置</span>
                <el-button type="text" size="small" @click="resetColumns">重置</el-button>
              </div>
              <el-checkbox-group v-model="selectedColumns" class="filter-checkboxes">
                <el-checkbox v-for="col in allColumns" :key="col.prop" :label="col.prop" :disabled="col.required">
                  {{ col.label }}
                </el-checkbox>
              </el-checkbox-group>
            </div>
            <el-button slot="reference" icon="el-icon-setting">列筛选</el-button>
          </el-popover>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" :fit="true" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column v-if="isColumnVisible('adId')" prop="adId" label="ID" header-align="center" align="center"></el-table-column>
        <el-table-column v-if="isColumnVisible('title')" prop="title" label="标题" header-align="center" align="center"></el-table-column>
        <el-table-column v-if="isColumnVisible('url')" prop="url" label="跳转地址" header-align="center" align="center"></el-table-column>
        <el-table-column v-if="isColumnVisible('img')" prop="img" label="广告图片" header-align="center" align="center">
          <template slot-scope="scope">
            <img :src="scope.row.img" width="100" height="40" alt=""/>
          </template>
        </el-table-column>
        <el-table-column v-if="isColumnVisible('hitCount')" prop="hitCount" label="点击数" header-align="center" align="center"></el-table-column>
        <el-table-column v-if="isColumnVisible('adType')" prop="adType" label="类型" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.adType == 1" type="success">首页弹框</el-tag>
            <el-tag v-if="scope.row.adType == 2" type="success">启动图</el-tag>
            <el-tag v-if="scope.row.adType == 3" type="success">视频列表随机广告</el-tag>
            <el-tag v-if="scope.row.adType == 4" type="success">轮播图</el-tag>
            <el-tag v-if="scope.row.adType == 5" type="success">排行广告</el-tag>
            <el-tag v-if="scope.row.adType == 6" type="success">小方格广告</el-tag>
            <el-tag v-if="scope.row.adType == 7" type="success">播放页广告</el-tag>
            <el-tag v-if="scope.row.adType == 8" type="success">暗网方格广告</el-tag>
            <el-tag v-if="scope.row.adType == 9" type="success">我的页面广告</el-tag>
          </template>
        </el-table-column>
        <el-table-column v-if="isColumnVisible('orderNo')" prop="orderNo" label="排序" header-align="center" align="center"></el-table-column>

        <el-table-column v-if="isColumnVisible('status')" prop="status" label="状态" header-align="center" align="center">
          <template v-slot:="scope">
            <el-button plain size="mini" :type="scope.row.status==1?'success':'danger'" @click="switchStatus(scope.row.id,scope.row.status==0?1:0)">{{ formatStatus(scope.row.status) }}</el-button>

          </template>
        </el-table-column>
        <el-table-column v-if="isColumnVisible('createDate')" prop="createDate" label="创建时间" header-align="center" align="center"></el-table-column>
<!--        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">-->
<!--          <template slot-scope="scope">-->
<!--            <el-button v-if="$hasPermission('adclickreport:adclickreport:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>-->
<!--            <el-button v-if="$hasPermission('adclickreport:adclickreport:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>-->
<!--          </template>-->
<!--        </el-table-column>-->
      </el-table>
      <el-pagination
          :current-page="page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="limit"
          :total="total"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="pageSizeChangeHandle"
          @current-change="pageCurrentChangeHandle">
      </el-pagination>

    </div>
  </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import dateTimeRangeMixin from '@/mixins/datetime-range'
export default {
  mixins: [mixinViewModule, dateTimeRangeMixin],
  data () {
    return {
      columnFilterVisible: false,
      allColumns: [
        { prop: 'adId', label: 'ID', required: false },
        { prop: 'title', label: '标题', required: false },
        { prop: 'url', label: '跳转地址', required: false },
        { prop: 'img', label: '广告图片', required: false },
        { prop: 'hitCount', label: '点击数', required: false },
        { prop: 'adType', label: '类型', required: false },
        { prop: 'orderNo', label: '排序', required: false },
        { prop: 'status', label: '状态', required: false },
        { prop: 'createDate', label: '创建时间', required: false }
      ],
      selectedColumns: [],
      exportScaleOptions:[
        {
          value: '1',
          label: '100%'
        },{
          value: '1.1',
          label: '110%'
        },{
          value: '1.2',
          label: '120%'
        },{
          value: '1.3',
          label: '130%'
        },{
          value: '1.4',
          label: '140%'
        },{
          value: '1.5',
          label: '150%'
        }
      ],
      // exportScaleOptionsValue:'',
      // 日期范围
      pDict:[
        {
          value: '1',
          label: '首页弹框'
        },{
          value: '2',
          label: '启动图'
        },{
          value: '3',
          label: '视频列表随机广告'
        },{
          value: '4',
          label: '轮播图'
        },{
          value: '5',
          label: '排行广告'
        },{
          value: '6',
          label: '小方格广告'
        },{
          value: '7',
          label: '播放页广告'
        },{
          value: '8',
          label: '暗网方格广告'
        },{
          value: '9',
          label: '我的页面广告'
        }
      ],
      mixinViewModuleOptions: {
        getDataListURL: '/adclickreport/adclickreport/page',
        getDataListIsPage: true,
        exportURL: '/adclickreport/adclickreport/export',

        deleteIsBatch: true
      },
      dateRange: null,
      dataForm: {
        id: '',
        type:'',
        startDate: null,
        endDate: null,
        exportScaleOptionsValue: ''
      }
    }
  },
  components: {

  },
  created() {
    this.initSelectedColumns()
  },
  methods:{
    // 初始化选中的列
    initSelectedColumns() {
      const saved = localStorage.getItem('adclickreport_selected_columns')
      if (saved) {
        this.selectedColumns = JSON.parse(saved)
      } else {
        this.selectedColumns = this.allColumns.map(col => col.prop)
      }
    },
    // 判断列是否可见
    isColumnVisible(prop) {
      return this.selectedColumns.includes(prop)
    },
    // 重置列选择
    resetColumns() {
      this.selectedColumns = this.allColumns.map(col => col.prop)
      this.saveColumnSettings()
    },
    // 保存列设置
    saveColumnSettings() {
      localStorage.setItem('adclickreport_selected_columns', JSON.stringify(this.selectedColumns))
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.dataForm.id = null;
      this.dataForm.exportScaleOptionsValue = null;
      this.dataForm.type = null;
      this.dateRange = null;
      this.dataForm.startDate = null;
      this.dataForm.endDate = null;

      this.getDataList();
    },
    handleOperChange(value) {
      this.dataForm.exportScaleOptionsValue = value;
    },
    getpSonDict(value) {
      this.dataForm.type = value;
    },
    formatStatus(status) {
      return status === 1 ? '启用' : '禁用';
    },
    switchStatus(id, status) {
      this.$http.put(`/adclickreport/adclickreport/status/${id}/${status}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg);
        }
        this.$message.success('状态更新成功');
        this.getDataList();
      }).catch(() => {});
    }
  },
  watch: {
    'dateRange'(val) {
      if (!val || val.length === 0) {
        this.dataForm.startDate = null
        this.dataForm.endDate = null
      } else {
        // datetimerange 已经包含完整的日期时间,直接赋值
        this.dataForm.startDate = val[0]
        this.dataForm.endDate = val[1]
      }
    },
    selectedColumns: {
      handler() {
        this.saveColumnSettings()
      },
      deep: true
    }
  },
}
</script>

<style lang="scss" scoped>
.column-filter-panel {
  .filter-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    padding-bottom: 8px;
    border-bottom: 1px solid #ebeef5;

    span {
      font-weight: 500;
      font-size: 14px;
    }
  }

  .filter-checkboxes {
    display: flex;
    flex-direction: column;
    gap: 8px;
    max-height: 400px;
    overflow-y: auto;

    ::v-deep .el-checkbox {
      margin-right: 0;
      margin-left: 0;
    }
  }
}
</style>
